/**
 * This module is in charge of controlling switch visual components.
 */
(function() {

  "use strict";


  define('fg-arv/fromToMarkers',['fg-arv/utils', 'fg-arv/google-helper', 'fg-arv/constants', 'fg-arv/libs/richmarker', 'fg-arv/libs/richmarkerPosition'], function(utils, googleHelper, constants, RichMarker, RichMarkerPosition) {

    var FromToMarkers = function(widget, config) {
      this.widget = widget;
      var that = this;

      google.maps.event.addListener(widget.getMap(), 'click', function(e) {
        if (widget.focusedLocation.getValue().name === '') {
          var coordinates = {
            lat: e.latLng.lat(),
            lng: e.latLng.lng()
          };

          googleHelper.getAddressLocationFromLatLngObject(e.latLng).done(function(value) {
            var mapPosition = {
              coordinates: coordinates,
              name: value.name,
              country: value.country
            };
            widget.triggerEvent(constants.events.locationSelected, mapPosition);

          });
        }
      });

      widget.addEventHandler(constants.events.locationChanged, function(eventData) {
        setTimeout(function() {
          that._updateMarker(eventData.changedLocation, eventData.movePosition);
        }, 100);
      });

      widget.addEventHandler(constants.events.addNewMarkers, function() {
        that._drawMarker(widget.fromComponent);
        that._drawMarker(widget.toComponent);

      });
      google.maps.event.addListener(widget.getMap(), 'dragstart', function(e) {
        widget.fromComponent.getElement().trigger('blur');
        widget.toComponent.getElement().trigger('blur');
      });
    };

    jQuery.extend(FromToMarkers.prototype, {

      _addDragendListener: function(locationControl) {
        var marker = locationControl.marker;
        google.maps.event.addListener(marker, 'dragend', function(e) {
          e.stopPropagation();
          var value = locationControl.getValue();
          value.coordinates = {
            lat: marker.getPosition().lat(),
            lng: marker.getPosition().lng()
          };
          value.name = googleHelper.getAddressLocationFromLatLngObject(marker.getPosition())
            .done(function(value) {
              locationControl.setValue(value, true);
              locationControl.setLatLon(marker.getPosition());
            });
        });
      },

      _updateMarker: function(inputLocation, movePosition) {
        if (inputLocation) {
          var map = this.widget.getMap();
          var marker = utils.getPropertyValue(inputLocation, 'marker');
          var value = inputLocation.getValue();
          var coordinates = utils.getPropertyValue(value, 'coordinates');

          if (!coordinates && marker) {
            marker.setMap(null);
          } else if (coordinates) {

            var position = new google.maps.LatLng(coordinates.lat, coordinates.lng);
            this._drawMarker(inputLocation);
            if (movePosition) {
              map.panTo(position);
            }
          }
        }
      },

      _drawMarker: function(inputLocation) {
        var map = this.widget.getMap();
        var marker = utils.getPropertyValue(inputLocation, 'marker');
        var value = inputLocation.getValue();
        var coordinates = utils.getPropertyValue(value, 'coordinates');
        if (!coordinates) {
          return;
        }
        var position = new google.maps.LatLng(coordinates.lat, coordinates.lng);
        if (!marker) {
          inputLocation.marker = new RichMarker({
            position: position,
            content: content,
            flat: true,
            anchor: RichMarkerPosition.BOTTOM_LEFT,
            height: '50px',
            draggable: true,
            map: map

          });
          this._addDragendListener(inputLocation);
          google.maps.event.addListener(inputLocation.marker, 'click', function(e) {
            e.stopPropagation();
          });
        } else if (marker.getMap() === null) {
          marker.setMap(map);
        } else {
          marker.setMap(map);
          marker.setPosition(position);
        }
        var content = document.createElement('div');
        content.className = inputLocation.getClass() + ' marker-icon';
        var insideContent = document.createElement('div');
        insideContent.className = 'inside';
        insideContent.innerHTML = inputLocation.getClass() === 'from' ? 'Origin' : 'Destination';
        content.appendChild(insideContent);
        inputLocation.marker.setContent(content);
        inputLocation.setLatLon(position);
      },
      hideMarker: function(inputLocation) {
        var marker = utils.getPropertyValue(inputLocation, 'marker');
        if (marker) {
          marker.setMap(null);

        }
      }
    });

    var module = {
      createComponent: function(widget, config) {
        return new FromToMarkers(widget, config);
      }
    };

    return module;
  });
})();
